import { useFetchData, useParseRouteActions } from "../../../helpers/GlobalHelper";
import LmsFormGenerator, { BCFormController } from "../ui/LmsFormGenerator";
import LmsTable from "../ui/LmsTable";
import { GlobalConstants } from "../../constants/GlobalConstants";

const MainTable = () => {
  const handleRemovePortfolioManager = (selectedIds) => {
    return selectedIds;
  };

  const actionButtons = [ 
      "add",
      "edit",
      {
        action: "submitselected",
        method: "DELETE",
        text: "Delete",
        submitSuffix: "salesteam/loan-officer-portfolio-managers", 
        confirmationMessage: "Are you sure that you want to delete these records?",
        data: handleRemovePortfolioManager,
        icon: GlobalConstants.Icons.DELETE,
        refreshDataOnSuccess: true,
      },
      "export"
    ];

  return <LmsTable
    actionButtons={actionButtons as any}
    apiSuffix="salesteam/loan-officer-portfolio-managers" 
    sortable={["Created On"]}
    columnLabelsDictionary={{
      loanOfficerOrganizationContact: "Loan Officer",
      portfolioManagerOrganizationContact: "Portfolio Manager"  
    }}
    formatDataFunc={(data) => data.map((a) => 
      {
        a.updateUnpaidLoans = a.updateUnpaidLoans === true ? "True" : "False";
        return a;
      })}
  />;
};

const loanOfficerPortfolioManagerFormFields = (myForm, isAdd =  false) => {
  if (!isAdd){
    myForm.addCenteredGroup([
      myForm.getDropdownField("Loan Officer", "salesteam/list-loan-officers", { name: "loanOfficerOrganizationContactId", required: true, disabled: true })
    ]);

  }else{
    myForm.addCenteredGroup([
      myForm.getDropdownField("Loan Officer", "salesteam/list-loan-officers", { name: "loanOfficerOrganizationContactId", required: true })
    ]);
  }
  myForm.addCenteredGroup([
    myForm.getDropdownField("Portfolio Manager", "metadata/list-portfolio-managers", { name: "portfolioManagerOrganizationContactId", required: true })
  ]);

  myForm.addCenteredGroup([myForm.getInputField("Update Unpaid Loans", { name: "updateUnpaidLoans", field: "checkbox", inline: true })]);
  myForm.addCenteredGroup([myForm.getTextareaField("Description", { name: "description" })]);
  return myForm;
};

const AddLoanOfficerPortfolioManagerForm = () => {
  const myForm = loanOfficerPortfolioManagerFormFields(new BCFormController({}, { submitSuffix: "salesteam/loan-officer-portfolio-manager", blankWidth: 4 }), true); 
  const formActions = ["save-new", "save-close", "close"];
  return (<LmsFormGenerator myForm={myForm} actions={formActions} />);
};

const EditLoanOfficerPortfolioManagerForm = ({ id }) => {
  const deleteSuffix = "salesteam/loan-officer-portfolio-managers";
  const [{ data = {}, isLoading, error }] = useFetchData(`salesteam/loan-officer-portfolio-manager/${id}`);
  const myForm = loanOfficerPortfolioManagerFormFields(new BCFormController(data, { submitSuffix: "salesteam/loan-officer-portfolio-manager", clearSuffixesOnSubmit: [id], deleteSuffix, blankWidth: 4 }), false); 
  const formActions = ["save", "save-close", "delete", "close"];
  return <LmsFormGenerator myForm={myForm} isLoading={isLoading} error={error} actions={formActions}/>;
};

const LmsSalesTeamLoanOfficerPortfolioManager = ({ params = {}, history }) => {
  const { isMainPage, isAdd, isEdit, isActionAllowed, id } = useParseRouteActions(params);
  if (!isActionAllowed) {
    history.goBack();
  }

  return (<>
    {isMainPage && <MainTable/>}
    {isAdd && <AddLoanOfficerPortfolioManagerForm />}
    {isEdit && <EditLoanOfficerPortfolioManagerForm id={id}/>}
  </>);
};

export default LmsSalesTeamLoanOfficerPortfolioManager;